import { computed, type ComputedRef, type Ref } from 'vue'
import { type ReactiveCookie, useBooleanCookie } from '@/plugins/cookie-plugin'

export const useGridViewToggle = (
    fetching: Readonly<Ref<boolean>>
): {
    tableView: ReactiveCookie<boolean>
    classGrid: ComputedRef<Record<string, boolean>>
} => {
    const tableView = useBooleanCookie('stone_table_view_preference')
    const classGrid = computed(() => ({
        'fetching': fetching.value,
    }))

    return {
        tableView,
        classGrid,
    }
}
